
// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Navbar from './components/Navbar.js';
import HeadingLayout from './components/HeadingLayout';
import Home from './pages/Home.js';
import About from './pages/About.js';
import Services from './pages/Services.js';
import HowWeWork from './pages/HowWeWork';
import Blog from './pages/Blog.tsx';
import Contact from './pages/Contact.js';
import BlogDetail from './components/Blog/BlogDetail.js';
import ScrollToTop from './components/ScrollToTop.js';
import NotFound from './pages/NotFound';
import Framework from './pages/SyncFramework.js'

function LegacyArticleRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/insights/${slug}`} replace />;
}

function App() {
  return (
    <Router>
      <HeadingLayout />
      <Navbar />
      <div id="main-content" tabIndex="-1" />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/sales-enablement" element={<Navigate to="/services/impact-communications" replace />} />
        <Route path="/services/:serviceSlug" element={<Services />} />
        <Route path="/how-we-help" element={<Navigate to="/services" replace />} />
        <Route path="/how-we-work-together" element={<HowWeWork />} />
        <Route path="/sync-framework" element={<Framework />} />
        <Route path="/insights" element={<Blog />} />
          <Route path="/insights/:slug" element={<BlogDetail />} />
        <Route path="/blog/:slug" element={<LegacyArticleRedirect />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
